/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoMarketGemRequest model module.
 * @module model/PerplayStatisticsControllerDtoMarketGemRequest
 * @version 1.0
 */
class PerplayStatisticsControllerDtoMarketGemRequest {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoMarketGemRequest</code>.
     * @alias module:model/PerplayStatisticsControllerDtoMarketGemRequest
     * @param beginDate {Date} 
     * @param endDate {Date} 
     */
    constructor(beginDate, endDate) { 
        
        PerplayStatisticsControllerDtoMarketGemRequest.initialize(this, beginDate, endDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, beginDate, endDate) { 
        obj['beginDate'] = beginDate;
        obj['endDate'] = endDate;
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoMarketGemRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoMarketGemRequest} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoMarketGemRequest} The populated <code>PerplayStatisticsControllerDtoMarketGemRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoMarketGemRequest();

            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('gemType')) {
                obj['gemType'] = ApiClient.convertToType(data['gemType'], 'String');
            }
            if (data.hasOwnProperty('gemLevel')) {
                obj['gemLevel'] = ApiClient.convertToType(data['gemLevel'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoMarketGemRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoMarketGemRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of PerplayStatisticsControllerDtoMarketGemRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['gemType'] && !(typeof data['gemType'] === 'string' || data['gemType'] instanceof String)) {
            throw new Error("Expected the field `gemType` to be a primitive type in the JSON string but got " + data['gemType']);
        }
        // ensure the json data is a string
        if (data['gemLevel'] && !(typeof data['gemLevel'] === 'string' || data['gemLevel'] instanceof String)) {
            throw new Error("Expected the field `gemLevel` to be a primitive type in the JSON string but got " + data['gemLevel']);
        }

        return true;
    }


}

PerplayStatisticsControllerDtoMarketGemRequest.RequiredProperties = ["beginDate", "endDate"];

/**
 * @member {Date} beginDate
 */
PerplayStatisticsControllerDtoMarketGemRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
PerplayStatisticsControllerDtoMarketGemRequest.prototype['endDate'] = undefined;

/**
 * @member {String} gemType
 */
PerplayStatisticsControllerDtoMarketGemRequest.prototype['gemType'] = undefined;

/**
 * @member {String} gemLevel
 */
PerplayStatisticsControllerDtoMarketGemRequest.prototype['gemLevel'] = undefined;






export default PerplayStatisticsControllerDtoMarketGemRequest;

